<template>
  <iframe
    class="native-map"
    :srcdoc="mapHtml"
    frameborder="0"
  />
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  import iframeCss from './native-yandex-map/iframe.css?raw';
  import iframeJsTemplate from './native-yandex-map/iframe.txt?raw';
  import markerSvg from './native-yandex-map/marker.svg?raw';

  const props = withDefaults(
    defineProps<{
      latitude: number;
      longitude: number;
      zoom?: number;
      behaviors?: string[];
    }>(),
    {
      zoom: 15,
      behaviors: () => ['pinchZoom', 'dblClick'],
    },
  );
  const API_KEY = import.meta.env.VITE_YANDEX_MAP_KEY ?? '05f23d6d-b09f-48e8-824f-67143f7e0de6';

  const apiUrl = `https://api-maps.yandex.ru/v3/?apikey=${API_KEY}&lang=ru_RU`;

  const mapHtml = computed(() => {
    const script = iframeJsTemplate
      .replace('__COORDS__', JSON.stringify([props.longitude, props.latitude]))
      .replace('__ZOOM__', String(props.zoom))
      .replace('__BEHAVIORS__', JSON.stringify(props.behaviors))
      .replace('__MARKER_SVG__', markerSvg.replace(/\n\s*/g, ''));

    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<style>${iframeCss}</style>
<script src="${apiUrl}"><\/script>
</head>
<body>
<div id="map"></div>
<script>${script}<\/script>
</body>
</html>`;
  });
</script>

<style lang="scss" scoped>
  .native-map {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
  }
</style>
